// @flow
/**
 * Base class for all the custom related exceptions
 */
export default class AppException extends Error {}
